// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-4fab79bf] .body {
  overflow-y: hidden !important;
}
.survey-msg-content[data-v-4fab79bf] {
  width: 100%;
  height: 100%;
}
.survey-msg-content iframe[data-v-4fab79bf] {
  border: none;
  width: calc(var(--vw) * 100);
  height: calc(var(--vh) * 70);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/ModalSurvey.vue"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;AAC9B","sourcesContent":["[data-v-4fab79bf] .body {\n  overflow-y: hidden !important;\n}\n.survey-msg-content[data-v-4fab79bf] {\n  width: 100%;\n  height: 100%;\n}\n.survey-msg-content iframe[data-v-4fab79bf] {\n  border: none;\n  width: calc(var(--vw) * 100);\n  height: calc(var(--vh) * 70);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
